import { api } from "@/lib/api";

let qzMod = null;

async function loadQz() {
  if (!qzMod) {
    qzMod = (await import("qz-tray")).default;
    qzMod.security.setCertificatePromise((resolve, reject) => {
      api.get("/qz/certificate", { responseType: "text" }).then((r) => resolve(r.data)).catch(reject);
    });
    qzMod.security.setSignatureAlgorithm("SHA512");
    qzMod.security.setSignaturePromise((toSign) => (resolve, reject) => {
      api.post("/qz/sign", { request: toSign }, { responseType: "text" }).then((r) => resolve(r.data)).catch(reject);
    });
  }
  return qzMod;
}

async function connect(qz) {
  if (qz.websocket.isActive()) return;
  await Promise.race([
    qz.websocket.connect({ retries: 0, delay: 0 }),
    new Promise((_, rej) => setTimeout(() => rej(new Error("QZ Tray not running")), 2500)),
  ]);
}

// Returns true if printed through QZ Tray, false if QZ Tray is unavailable.
export async function qzPrintPdf(blob) {
  try {
    const qz = await loadQz();
    await connect(qz);
    const printer = await qz.printers.getDefault();
    if (!printer) return false;
    const b64 = await new Promise((res, rej) => {
      const fr = new FileReader();
      fr.onload = () => res(String(fr.result).split(",")[1]);
      fr.onerror = rej;
      fr.readAsDataURL(blob);
    });
    const cfg = qz.configs.create(printer, { units: "mm", size: { width: 80 }, margins: 0, scaleContent: false, colorType: "blackwhite" });
    await qz.print(cfg, [{ type: "pixel", format: "pdf", flavor: "base64", data: b64 }]);
    return printer;
  } catch (e) {
    return false;
  }
}
